<template>
  <va-modal
    v-model="toOpenModal"
    :title="$t('modals.client.title')"
    :hideDefaultActions="true"
    :noOutsideDismiss="true"
    :noEscDismiss="true"
  >
    <SwappingSquaresSpinner v-if="modalLoader"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: 30px auto;"
    />
    <form v-if="!modalLoader && !showCode">
      <div class="row">
        <div class="flex xs12" v-if="showLocation">
          <va-select
            :label="$t('modals.client.selectLocation')"
            v-model="editClient.event"
            @input="onLocationChange"
            textBy="name"
            keyBy="eventId"
            :options="locations"
            :error="!!locationErrors.length"
          />
        </div>
        <div class="flex xs12">
          <va-input
            v-model="editClient.plate"
            type="text"
            :label="$t('modals.client.inputPlate')"
          />
        </div>
        <div class="flex xs12" style="margin: 0 0 10px 0;">
          <vue-tel-input
            :validCharactersOnly="true"
            mode="international"
            v-model="editClient.mobile"
            id="inputMobile"
            :placeholder="$t('modals.client.placeholderPhone')"></vue-tel-input>
        </div>
        <div class="flex xs12">
          <fieldset>
            <va-checkbox
              :label="$t('modals.client.checkboxSpot')"
              v-model="editClient.isSpotAutoSelected"
            />
          </fieldset>
        </div>
        <div class="flex xs12">
          <fieldset>
            <va-checkbox
              :label="$t('modals.client.checkboxEmployee')"
              :disabled="Object.keys(editClient.event).length === 0"
              v-model="editClient.isEmployeeAutoSelected"
            />
          </fieldset>
        </div>
        <div class="flex xs12" v-if="Object.keys(editClient.event).length !== 0 && !editClient.isEmployeeAutoSelected">
          <va-select
            :label="$t('modals.client.selectEmployee')"
            v-model="editClient.user"
            textBy="name"
            keyBy="userId"
            :options="users"
            :error="!!userError.length"
          />
        </div>
        <div class="flex xs12" v-if="showEventSpot && !editClient.isSpotAutoSelected">
          <va-select v-if="theLocationId"
            :label="$t('modals.client.selectClassification')"
            v-model="spotClassification"
            textBy="name"
            keyBy="spotClassificationId"
            :options="theSpotClassifications"
            :error="!!spotsError.length"
          />
          <div v-if="!theLocationId">{{ $t('modals.client.pleaseSelectLocation') }}</div>
          <va-select v-if="theSpotClassificationId"
            :label="$t('modals.client.selectSpot')"
            v-model="editClient.eventSpot"
            keyBy="eventSpotId"
            textBy="spotIdentifier"
            :options="theSpots"
            :error="!!spotsError.length"
          />
          <div v-if="!theSpotClassificationId">{{ $t('modals.client.pleaseSelectClassification') }}</div>
        </div>
        <div class="flex xs12">
          <fieldset>
            <va-checkbox
              :label="$t('modals.client.checkboxSubscription')"
              v-model="editClient.isDefaultAppSubscription"
            />
          </fieldset>
        </div>
        <div class="flex xs12" v-if="!editClient.isDefaultAppSubscription">
          <va-select
            :label="$t('modals.client.selectSubscription')"
            v-model="editClient.appSubscription"
            textBy="name"
            keyBy="appSubscriptionId"
            :options="theAppSubscriptions"
            :error="!!appSubscriptionError.length"
          />
        </div>
        <div class="flex xs12">
          <fieldset>
            <va-checkbox
              disabled
              :label="$t('modals.client.checkboxClient')"
              v-model="editClient.makeClientCheckIn"
            />
          </fieldset>
        </div>
        <div class="flex xs12">
          <fieldset>
            <va-checkbox
              :label="$t('modals.client.checkboxTicket')"
              v-model="editClient.isTicketAutoGenerated"
            />
          </fieldset>
        </div>
        <div class="flex xs12">
          <va-input v-if="!editClient.isTicketAutoGenerated"
            v-model="editClient.ticket"
            type="text"
            :label="$t('modals.client.inputTicket')"
            class="flex xs12"
            :error="!!ticketErrors.length"
            :error-messages="ticketErrors"
          />
        </div>
        <div class="flex xs12">
          <fieldset>
            <va-checkbox
              :label="$t('modals.client.checkboxInfo')"
              v-model="showAdvanced"
            />
          </fieldset>
        </div>
        <div class="flex xs12" v-if="showAdvanced">
          <va-input
            v-model="editClient.name"
            type="text"
            :label="$t('modals.client.inputName')"
            class="flex xs12"
          />
          <va-input
            v-model="editClient.surname"
            type="text"
            :label="$t('modals.client.inputSurname')"
            class="flex xs12"
          />
          <va-input
            v-model="editClient.email"
            type="email"
            :label="$t('modals.client.inputEmail')"
            class="flex xs12"
          />
          <va-input
            v-model="editClient.carColor"
            type="text"
            :label="$t('modals.client.inputColor')"
            class="flex xs12"
          />
          <va-input
            v-model="editClient.carModel"
            type="text"
            :label="$t('modals.client.inputModel')"
            class="flex xs12"
          />
        </div>
      </div>
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click.prevent="disableModal()" class="my-0 ">{{ $t('modals.client.btnClose') }}</va-button>
        <va-button type="submit" @click.prevent="onsubmit()" class="my-0">{{ $t('modals.client.btnCreate') }}</va-button>
      </div>
    </form>
    <div class="row" v-if="!modalLoader && showCode">
      <div class="flex xs12">
        <div v-if="!isCameraShow">
          <va-button outline color="gray" icon="fa fa-print" @click.prevent="printCode"> {{ $t('modals.client.print') }}</va-button>
          <div id="printCode" class="receipt">
            <qrcode-vue render-as="svg" :value="codeValue" size="100" level="H"></qrcode-vue>
            <ul>
              <li>{{client.checkIn | moment("DD.MM.YYYY HH:mm")}}</li>
              <li>{{ $t('modals.client.spot') }} {{client.spotIdentifier}}</li>
              <li>{{ $t('modals.client.ticket') }} #{{client.ticket}}</li>
              <li v-if="client.plate !== null && client.plate.length > 3">{{ $t('modals.client.plate') }} {{client.plate}}</li>
              <li>{{ $t('modals.client.code') }} {{client.identifier}}</li>
            </ul>
          </div>
        </div>
        <div v-if="isCameraShow">
          <Alpr @theClient="getClient" :client-id="client.clientId"></Alpr>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" v-if="showCode && !isCameraShow" @click.prevent="enableAlpr()" class="my-0 ">{{ $t('modals.client.btnRecognition') }}</va-button>
          <!--          <va-button color="gray" v-if="isCameraShow" @click.prevent="enableAlpr()" class="my-0 ">Car Recognition</va-button>-->
          <va-button color="gray" @click.prevent="disableModal()" class="my-0 ">{{ $t('modals.client.btnClose') }}</va-button>
        </div>
      </div>
    </div>
  </va-modal>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { SwappingSquaresSpinner } from 'epic-spinners'
import { VueTelInput } from 'vue-tel-input'
import Alpr from '../scanner/Alpr'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  name: 'ClientCreateModal',
  mixins: [errorHandlerMixin],
  components: {
    QrcodeVue,
    SwappingSquaresSpinner,
    VueTelInput,
    Alpr,
  },
  data () {
    return {
      client: {},
      showLocation: false,
      showEventSpot: false,
      modalLoader: false,
      locations: [],
      showAdvanced: false,
      showCode: false,
      appSubscriptions: [],
      appSubscription: {},
      spotClassifications: [],
      spotClassification: {},
      spots: [],
      ticketErrors: [],
      spotsError: [],
      locationErrors: [],
      appSubscriptionError: [],
      codeValue: '',
      isCameraShow: false,
      camera: null,
      deviceId: null,
      devices: [],
      editClient: {
        index: '',
        clientId: '',
        email: '',
        name: '',
        surname: '',
        mobile: '',
        carModel: '',
        carColor: '',
        plate: '',
        ticket: '',
        isSpotAutoSelected: true,
        isEmployeeAutoSelected: true,
        isTicketAutoGenerated: true,
        isDefaultAppSubscription: true,
        makeClientCheckIn: true,
        appSubscription: {},
        eventSpot: {},
        event: {},
        user: {},
      },
      oldSpotClassificationId: null,
      classificationChanged: false,
      users: [],
      userError: [],
    }
  },
  props: {
    locationId: Number,
    eventSpotId: Number,
    openModal: Boolean,
  },
  methods: {
    getClient (state) {
      this.client = state
      this.modalLoader = false
      this.isCameraShow = false
    },
    closeAlpr (state) {
      this.isCameraShow = false
      this.modalLoader = true
    },
    onLocationChange (e) {
      if (e.eventId) {
        this.$store.dispatch('appUserLocationRequest', e.eventId).then((resp) => this.initUsers(resp.data.message))
      }
    },
    async initUsers (users) {
      this.users.splice(0, this.users.length, ...users)
    },
    enableAlpr () {
      this.isCameraShow = true
    },
    async createModal () {
      if (!this.locationId) {
        this.showLocation = true
        if (this.locations.length < 1) {
          this.modalLoader = true
          await this.getTheLocations()
        }
      }
      if (!this.eventSpotId) {
        this.showEventSpot = true
      }
    },
    disableModal () {
      this.editClient.index = ''
      this.editClient.clientId = ''
      this.editClient.email = ''
      this.editClient.name = ''
      this.editClient.surname = ''
      this.editClient.mobile = ''
      this.editClient.carModel = ''
      this.editClient.carColor = ''
      this.editClient.plate = ''
      this.editClient.ticket = ''
      this.editClient.event = {}
      this.editClient.isSpotAutoSelected = true
      this.editClient.isEmployeeAutoSelected = true
      this.editClient.isTicketAutoGenerated = true
      this.editClient.isDefaultAppSubscription = true
      this.editClient.makeClientCheckIn = true
      this.editClient.appSubscription = {}
      this.editClient.eventSpot = {}
      this.editClient.user = {}
      this.locationErrors = []
      this.openEditModal = false
      this.removeDisabled = false
      this.showAdvanced = false
      this.showCode = false
      this.locations = []
      this.users = []
      this.$emit('closemodal', false)
    },
    onsubmit () {
      if (this.showLocation) {
        this.locationErrors = Object.keys(this.editClient.event).length !== 0 ? [] : [this.$t('modals.client.requiredLocation')]
      }

      if (!this.editClient.isTicketAutoGenerated) {
        this.ticketErrors = this.editClient.ticket ? [] : [this.$t('modals.client.requiredTicket')]
      } else {
        this.ticketErrors = []
      }

      if (!this.editClient.isEmployeeAutoSelected) {
        this.userError = Object.keys(this.editClient.user).length !== 0 ? [] : [this.$t('modals.client.requiredEmployee')]
      } else {
        this.userError = []
      }

      if (!this.editClient.isSpotAutoSelected) {
        this.spotsError = Object.keys(this.editClient.eventSpot).length !== 0 ? [] : [this.$t('modals.client.requiredSpot')]
      } else {
        this.spotsError = []
      }

      if (!this.editClient.isDefaultAppSubscription) {
        this.appSubscriptionError = Object.keys(this.editClient.appSubscription).length !== 0 ? [] : [this.$t('modals.client.requiredSubscription')]
      } else {
        this.appSubscriptionError = []
      }

      if (!this.formClientSubmitReady) {
        return
      }

      let locationId = this.locationId
      if (this.showLocation) {
        locationId = this.editClient.event.eventId
      }

      let employeeId = null
      if (!this.editClient.isEmployeeAutoSelected) {
        employeeId = this.editClient.user.userId
      }

      let eventSpotId = this.eventSpotId
      if (this.showEventSpot) {
        eventSpotId = this.editClient.eventSpot.eventSpotId
      }

      let appSubscriptionId = null
      if (!this.editClient.isDefaultAppSubscription) {
        appSubscriptionId = this.editClient.appSubscription.appSubscriptionId
      }
      this.modalLoader = true
      this.$store.dispatch('clientCreate', {
        email: this.editClient.email,
        name: this.editClient.name,
        surname: this.editClient.surname,
        mobile: this.editClient.mobile,
        carModel: this.editClient.carModel,
        carColor: this.editClient.carColor,
        plate: this.editClient.plate,
        ticket: this.editClient.ticket,
        isTicketAutoGenerated: this.editClient.isTicketAutoGenerated,
        isSpotAutoSelected: this.editClient.isSpotAutoSelected,
        isEmployeeAutoSelected: this.editClient.isEmployeeAutoSelected,
        eventSpotId: eventSpotId,
        eventId: locationId,
        appSubscriptionId: appSubscriptionId,
        employeeId: employeeId,
        makeClientCheckIn: this.editClient.makeClientCheckIn,
        isDefaultAppSubscription: this.editClient.isDefaultAppSubscription,
      }).then((resp) => {
        this.afterSubmit(resp.data.message)
        this.disableModal()
      })
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
    },
    afterSubmit (client) {
      this.$emit('update', client)
      this.client = client
      this.codeValue = 'https://' + this.$store.getters.namespace + '.valet.live/=spot/code/' + this.client.spotCodeIdentifier
      this.showCode = true
      this.modalLoader = false
      this.sendRequestStatus(client.clientId, '', 'dashboard', 'newclient')
    },
    async sendRequestStatus (identifier, status, scope, messageScope) {
      // await this.$socket.invoke('ProgressUpdate', identifier, status, scope, this.$store.getters.localUser.email, messageScope, null, this.$store.getters.namespace)
    },
    async getTheLocations () {
      if (this.$store.getters.locations.length === 0) {
      }
      await this.$store.dispatch('getLocations')
        .then(resp => this.initlocations())
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
    },
    async initlocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
      this.modalLoader = false
    },
    async getAppSubscriptions () {
      if (this.appSubscriptions.length === 0) {
        await this.$store.dispatch('getLocationAppSubscriptions', this.theLocationId)
          .then((resp) => {
            return this.initAppSubscriptions(resp.data.message)
          }).catch(error => {
            this.errorHandler(error.response)
            this.modalLoader = false
          })
      }
    },
    async initAppSubscriptions (appSubscriptions) {
      this.appSubscriptions.splice(0, this.appSubscriptions.length, ...appSubscriptions)
      return this.appSubscriptions
    },
    async getSpotClassifications () {
      if (this.oldSpotClassificationId === null || this.oldSpotClassificationId !== this.theSpotClassificationId) {
        this.$store.dispatch('getClassifications', this.theLocationId)
          .then((resp) => {
            return this.initClassifications(resp.data.message)
          }).catch(error => {
            this.errorHandler(error.response)
            this.modalLoader = false
          })
        this.showEventSpot = true
        this.classificationChanged = true
        this.oldSpotClassificationId = this.theSpotClassificationId
      }
    },
    async initClassifications (spotClassifications) {
      this.spotClassifications.splice(0, this.spotClassifications.length, ...spotClassifications)
      return this.spotClassifications
    },
    async getTheSpots () {
      if (this.classificationChanged) {
        this.$store.dispatch('getSpots', this.theSpotClassificationId)
          .then((resp) => {
            return this.initSpots(resp.data.message)
          }).catch(error => {
            this.errorHandler(error.response)
            this.modalLoader = false
          })
        this.classificationChanged = false
      }
    },
    async initSpots (spots) {
      this.spots.splice(0, this.spots.length, ...spots)
      return this.spots
    },
    printCode () {
      this.$htmlToPaper('printCode')
    },
  },
  computed: {
    formClientSubmitReady () {
      return !(this.ticketErrors.length || this.spotsError.length || this.locationErrors.length || this.appSubscriptionError.length || this.userError.length)
    },
    toOpenModal () {
      if (this.openModal) {
        this.createModal()
        return true
      } else {
        return false
      }
    },
    theLocationId () {
      if (this.locationId) {
        return this.locationId
      } else if (Object.keys(this.editClient.event).length !== 0) {
        return this.editClient.event.eventId
      }
      return false
    },
    theSpotClassificationId () {
      if (this.spotClassification) {
        return this.spotClassification.spotClassificationId
      }
      return false
    },
    theSpots () {
      if (this.toOpenModal && this.theSpotClassificationId && !this.editClient.isSpotAutoSelected) {
        this.getTheSpots()
        return this.spots
      } else {
        return []
      }
    },
    theSpotClassifications () {
      if (this.toOpenModal && this.theLocationId && !this.editClient.isSpotAutoSelected) {
        this.getSpotClassifications()
        return this.spotClassifications
      } else {
        return []
      }
    },
    theAppSubscriptions () {
      if (this.toOpenModal && this.theLocationId && !this.editClient.isDefaultAppSubscription) {
        this.getAppSubscriptions()
        return this.appSubscriptions
      } else {
        return []
      }
    },
  },
  mounted () {
  },
}
</script>

<style scoped>
.receipt {
  text-align: center;
}
</style>
